import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getUserdef16,
  setCookie,
  getCookie
} from './utils/cookieinfo'

NProgress.configure({
  showSpinner: false
});

// 名单
let authList = [
  '/user/userInfo',
  '/user/questionnaire',
  '/user/confirmation',
  '/user/appointment',
  '/user/invitefriends',
  '/step/stepuserinfo',
  '/step/stepquestion',
  '/step/stepinvite',
  '/step/stepinvitecolleagues'
]

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  let showdetailsid = to.query.showdetailsid || "";
  let exh = to.query.exh || "";
  let showname = '';
  let userdef16 = getUserdef16();
  await store.dispatch('getDetails',{
    showdetailsid,
    exh
  }).then(data=>{
    if(data.languageID == 1) {
      if (to.meta && to.meta.title_zh) {
        document.title = to.meta.title_zh
      }
    } else if (data.languageID == 2) {
      if (to.meta && to.meta.title_en) {
        document.title = to.meta.title_en
      }
    }
    if (to.path == '/login') {
      if (userdef16) {
        next(`/user/confirmation?u=${userdef16}&showdetailsid=${showdetailsid}&exh=${exh}`)
      }
    }
    if (authList.includes(to.path)) {
      if (!userdef16) {
        next(`/login?showdetailsid=${showdetailsid}&exh=${exh}`)
      }
    }
    next()
  })
})

router.afterEach(async (to, from) => {
  if(store.state.lang == 2) {
    if(!document.getElementById('google-track-js')) {
      var src = 'https://www.googletagmanager.com/gtag/js?id=UA-27944749-1'
      var script = document.createElement('script')
          script.id = 'google-track-js'
          script.type='text/javascript'
          script.src = src
      var s = document.getElementsByTagName("script")[0]
          s.parentNode.insertBefore(script, s)
    }

    if(!document.getElementById('google-track')) {
      var script2 = document.createElement('script')
          script2.type='text/javascript'
          script2.id = 'google-track'
          script2.innerHTML = `
            window.dataLayer = window.dataLayer || []
            function gtag(){
              dataLayer.push(arguments)
            }
            gtag('js', new Date())
            gtag('config', 'UA-27944749-1')
            gtag('config', 'AW-815876776')
            gtag('config', 'AW-664841414')
            gtag('config', 'AW-664805592')
            gtag('config', 'AW-664841195')
            gtag('config', 'AW-664841120')
            console.log('谷歌统计代码')
         `
        document.body.appendChild(script2)
    }
  }
  NProgress.done();
})



// WEBPACK FOOTER //
// ./src/routerWatch.js